import type { IPusherConfigWithTest } from '@/shared/providers/pusher-provider'

export const isDesktopApp = document.body.dataset.desktopApp === 'true'

export const isWebApp = !isDesktopApp

export function pusherConfig(): IPusherConfigWithTest {
  if (isDesktopApp) {
    return window.desktopAppConfig!.pusherConfig
  }

  return window.appConfig!.pusherConfig
}

let pageProps: { pathName: string; props: Nullable<Record<string, unknown>> } | null = null
export function initPageProps() {
  pageProps = null

  if (isDesktopApp) {
    pageProps = { pathName: location.pathname, props: window.desktopAppConfig!.pageProps }
  } else {
    pageProps = { pathName: location.pathname, props: window.appConfig!.pageProps }
  }
}

export function getPageProps<T>(pathName: string): Nullable<T> {
  if (pageProps?.pathName !== pathName) {
    return null
  }

  return pageProps?.props as T
}
